import { useBahasa } from '../../../app/i18n'
import { useSambunganSaya } from '../../../domains/tenancy/api'
import { sejak } from '../../../shared/lib/waktu'
import {
  Baris, Bendera, Chip, Gagal, KepalaHalaman, Kosong, Memuat, Panel, Tabel,
} from '../../../shared/ui'

/**
 * SAMBUNGAN — akun media sosial dan grup Telegram milik tenant ini.
 *
 * DIBACA SAJA, DAN ITU BUKAN KEKURANGAN. `social_accounts.external_account_id` unik
 * GLOBAL dan menentukan webhook Meta masuk ke tenant mana; salah sambung di sana merusak
 * routing tenant LAIN. Jadi menambah dan mencabut tetap di tangan operator Smova, dan yang
 * dikembalikan ke admin tenant adalah HAK MELIHAT — supaya "kenapa Instagram saya tidak
 * membalas" bisa dijawab sendiri, tanpa menebak.
 *
 * Rancangan menggambarkan tombol "Hubungkan akun baru" yang mengarahkan ke login Meta.
 * Itu alur OAuth yang belum dibangun, dan tombol yang tidak menghubungkan apa pun lebih
 * buruk daripada tidak ada tombol.
 */

/** Tiga keadaan kapabilitas, dan ketiganya menuntut jawaban berbeda saat klien bertanya. */
function Kap({ nilai, t }) {
  if (nilai === 'bisa') return <Chip nada="ok">{t('ta.kapBisa')}</Chip>
  // "Belum dibangun" SENGAJA dibedakan dari "tidak bisa": yang pertama punya tanggal,
  // yang kedua tidak akan pernah ada. Meleburkannya menghapus jawaban atas "kapan bisa?".
  if (nilai === 'belum_dibangun') return <Chip nada="warn">{t('ta.kapBelum')}</Chip>
  return <Chip nada="idle">{t('ta.kapTidak')}</Chip>
}

export default function SambunganSaya() {
  const { t, locale } = useBahasa()
  const q = useSambunganSaya()

  if (q.isLoading) return <Memuat tinggi={6} />
  if (q.isError) return <Gagal galat={q.error} ulangi={q.refetch} />

  const akun = q.data?.akun ?? []
  const grup = q.data?.grup ?? []

  return (
    <>
      <KepalaHalaman judul={t('ta.navSambungan')} keterangan={t('ta.sambunganCatatan')} />

      {/* Hitungannya yang TERSAMBUNG, bukan jumlah baris: tabel ini sengaja memuat
          platform yang belum dihubungkan supaya terlihat bahwa ia ada. "4 tersambung"
          untuk satu akun Instagram akan berbohong. */}
      <Panel
        judul={t('ta.akunMedsos')}
        catatan={t('ta.akunMedsosCatatan', { n: akun.filter((a) => a.akun).length })}
      >
        <Tabel kepala={[t('ta.kolPlatform'), t('ta.kolAkun'), t('ta.kolTerakhirTerima'),
                        t('ta.kolBalasDm'), t('ta.kolBalasKomentar'), t('ta.kolTerbit')]}>
          {akun.map((a) => (
            <Baris key={a.platform}>
              <td className="font-semibold">{a.label}</td>
              <td className="font-mono text-[11.5px] text-ink2">
                {a.akun || <span className="text-ink3">{t('ta.belumDihubungkan')}</span>}
              </td>
              <td className="text-[11.5px] text-ink2">
                {/* Akun yang belum pernah menerima apa pun TIDAK sama dengan akun yang
                    baru saja menerima — dan kolom ini satu-satunya yang membedakannya.
                    Token yang diam-diam mati terlihat persis seperti akun sehat di
                    kolom lain. */}
                {a.terakhir_menerima
                  ? sejak(a.terakhir_menerima, locale)
                  : <span className="text-ink3">{t('ta.belumPernah')}</span>}
              </td>
              <td><Kap nilai={a.balas_dm} t={t} /></td>
              <td><Kap nilai={a.balas_komentar} t={t} /></td>
              <td><Kap nilai={a.terbit} t={t} /></td>
            </Baris>
          ))}
        </Tabel>
      </Panel>

      <Bendera nada="info" judul={t('ta.kapBedaJudul')} className="max-w-[80ch]">
        {t('ta.kapBedaIsi')}
      </Bendera>

      <Panel judul={t('ta.grupJudul')} catatan={t('ta.grupCatatanTenant')}>
        {grup.length === 0 ? (
          <Kosong judul={t('ta.grupKosongTenant')} />
        ) : (
          <Tabel kepala={[t('ta.kolLabel'), t('ta.kolChatId'), t('ta.kolIsiNotifikasi'),
                          t('ta.kolAktif')]}>
            {grup.map((g) => (
              <Baris key={g.chat_id}>
                <td className="font-semibold">
                  {g.label || <span className="text-ink3">—</span>}
                </td>
                <td className="font-mono text-[11.5px] text-ink2">{g.chat_id}</td>
                {/* SEMUA notifikasi masuk ke SEMUA grup aktif hari ini — tidak ada kolom
                    yang memilahnya, dan menampilkan penyaring yang tidak menyaring apa pun
                    akan berbohong tentang kemampuan yang belum ada. */}
                <td className="text-[11.5px] text-ink2">{t('ta.isiNotifikasiSemua')}</td>
                <td>
                  <Chip nada={g.aktif ? 'ok' : 'idle'}>
                    {g.aktif ? t('adm.aktif') : t('adm.nonaktif')}
                  </Chip>
                </td>
              </Baris>
            ))}
          </Tabel>
        )}
      </Panel>

      <Bendera nada="info" judul={t('ta.grupBukanIzinJudul')} className="max-w-[80ch]">
        {t('ta.grupBukanIzinIsi')}
      </Bendera>

      <Bendera nada="info" judul={t('ta.sambunganSiapa')} className="max-w-[80ch]">
        {t('ta.sambunganRencana')}
      </Bendera>
    </>
  )
}
